import styled from '@emotion/styled'
import React, { useState } from 'react'

type Props = {
  values: string[]
  onChange: (selectedIndex: number[]) => void
}

export const AmongUsSelector: React.FC<Props> = ({ onChange, values }) => {
  const [current, setCurrent] = useState<number[]>([])
  const names = [
    'ホワイト',
    'オレンジ',
    'グリーン',
    'イエロー',
    'パープル',
    'ブルー',
    'レッド',
    'ピンク',
    'ブラウン',
    'グレー',
    'ライトグリーン',
    'ライトブルー',
  ]
  const items = values.map((v, index) => {
    return (
      <Item
        onClick={() => {
          const newVal = current.includes(index)
            ? current.filter((c) => c !== index)
            : current.concat(index)
          setCurrent(newVal)
          onChange(newVal)
        }}
        selected={current.includes(index)}
        key={v}
      >
        <img src={v} alt={names[index]} />
      </Item>
    )
  })
  return <Container>{items}</Container>
}

const Container = styled.div`
  width: 100%;
  border: 3px solid #b7d7ea;
  background-color: #fff;
  border-radius: 4px;
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
`

const Item = styled.div<{ selected: boolean }>`
  width: 40px;
  height: 50px;
  border: 4px solid ${({ selected }) => (selected ? '#b7d7ea' : 'transparent')};
  background-color: transparent;
  border-radius: 4px;
`
